import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZendeskRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#337DA8",
		d: "M24 20.4a7 7 0 0 0-6.9 7H31a7 7 0 0 0-7-7m-9-9.8L1 27.4h13.9zm-14-6a7 7 0 1 0 13.9 0zm16.1 0v16.8L31 4.6z"
	})
});
export default SvgZendeskRegularIcon;
